import { useMemo } from "react"
import { isEmpty } from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import { Divider, Tooltip } from "@mui/material"
import Grid from "@mui/material/Grid"
import { AutoAwesome } from "@mui/icons-material"
import { APP_DATE_FORMAT } from "helpers/formatters/dates"
import { DATE_FORMAT } from "helpers/dates"
import { useModels } from "resources/models"
import { OK } from "helpers/data-statuses"
import { HEADER_PROPS } from "../shapes"
import Benchmark from "./benchmark"
import Toolbar from "./toolbar"

export default function Header({ headerButtons, isGenerated, timestamp, resource, model, startDate, endDate, showDateRange, base }) {
  const resourceName = resource?.name
  const modelId = model?.id
  const [models, modelsStatus] = useModels()
  const modelName = useMemo(() => {
    if (model?.name) {
      return model.name
    }
    if (modelsStatus === OK && model?.id) {
      const currentModel = models.find(m => m.id === model.id)
      return currentModel?.name
    }
    return null
  }, [models, modelsStatus, model])

  const isGeneratedText = isGenerated ? `Generated on ${timestamp?.format("MMMM Do YYYY, h:mm:ss a")}` : null

  return (
    <>
      <div className="toolbar">
        <Grid
          spacing={0}
          container
          sx={{
          justifyContent: "space-between",
        }}
        >
          <Grid sx={{
            alignContent: "center",
          }}
          >
            <h2><AutoAwesome /><span>Auto-generated summary for <b>{resourceName}</b></span></h2>
          </Grid>
          <Toolbar id="header-toolbar" buttons={headerButtons} />
        </Grid>
        <Divider />
      </div>
      <div className="header-wrapper">
        <Grid
          className="header"
          container
          direction="row-reverse"
          spacing={1}
          wrap="nowrap"
          sx={{
          justifyContent: "flex-end",
        }}
        >
          <Grid>
            {isGenerated
            && <Tooltip className="generated-on-wrapper" title={isGeneratedText}>
              <div className="generated-on">{isGeneratedText}</div>
            </Tooltip>}
          </Grid>
          <Grid className="details">
            <ul>
              <li className="summary-header-line"><span className="label">Model: </span><span className="id">({modelId})</span> {modelName}</li>
              <li className="summary-header-line"><DateDisplay {...{ startDate, endDate, showDateRange }} /></li>
              {!isEmpty(base) && <li className="summary-header-line"><Benchmark {...base} /></li>}
            </ul>
          </Grid>
        </Grid>
        <Divider />
      </div>
    </>
  )
}

Header.propTypes = HEADER_PROPS

function DateDisplay({ startDate, endDate, showDateRange }) {
  if (showDateRange) {
    return <><span className="label">Period: </span> {moment(startDate, DATE_FORMAT).format(APP_DATE_FORMAT)} to {moment(endDate, DATE_FORMAT).format(APP_DATE_FORMAT)}</>
  }
  return <><span className="label">Date: </span> {moment(endDate, DATE_FORMAT).format(APP_DATE_FORMAT)}</>
}

DateDisplay.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  showDateRange: PropTypes.bool,
}
